export default __webpack_public_path__ + "static/media/TimeOut.0728f307.svg";